import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListRel from '../../../components/saude/documentos/relatorioanual';


function ListRelScreen() {
    return (
        <Fragment>
            <Head titulo="Relatórios Anuais da Gestão de Saúde em Macuco" />
            <Header />
            <Container>
               <ListRel /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListRelScreen;